import vue from 'vue'

export default {
  CREATE_ORDER_CUSTOMER_DATA (state, params) {
    const odersCustomerId = params.variationId
    vue.set(state.odersCustomer, odersCustomerId, { ...params })
    this.commit('odersCustomer/SET_ORDER_CUSTOMER_ID', odersCustomerId)
  },

  SET_ORDER_CUSTOMER_ID (state, odersCustomerId) {
    state.odersCustomerId = odersCustomerId
  },

  SAVE_LOCAL_STORAGE (state) {
    localStorage.setItem('odersCustomer', JSON.stringify(state.odersCustomer))
    localStorage.setItem('odersCustomerId', JSON.stringify(state.odersCustomerId))
  },

}
